import React from "react";



const Website = () => {
return(
    
<>
<section class="about1" id="">

<div class="max-width" >
{/* <!-- <h2 class="title">About me</h2> --> */}
<div class="about-content">

<div class=" right">
<div class="text">Website Development</div>
<h3>Best Website Development for your Brand<br/>
<span>ShellCode Solutions, the best Website Development Company in Mumbai, is here for your every need. We create modern and sophisticated websites with engaging UI that keeps your consumers engaged and hooked. Our services come at pocket-friendly prices and are customizable as per your requirements. Ever heard a deal sound so good? Then what are you waiting for?<br/>
Get the website your brand deserves!<br/>
We establish you in the online market!
</span>
</h3>
</div>
<div class=" left">
<img src="assets/images/1.png" alt="1"/>
</div>
</div>

</div>
</section>
<div className="extra">
    <h3>Our Website Development strategy<br/>
        <span>
        We are here for you always! Whether you are an established brand or a small and flourishing business, we will design the perfect website for you. Our team of developers is flexible in their development processes according to your requirements. Your wish becomes our command. We research extensively about your niche and industry so that we can target the correct consumer base. We build SEO-friendly websites with a responsive UI and UX, attracting leads and increasing your conversion rate. With us, you get to rule the online market. The choice is yours!<br/>
        Our designers get you!<br/>
        </span>
    </h3>
    <h3>User Experience Design<br/>
        <span>
        An engaging and interactive UI and UX is a key to an attractive website, which pulls more leads. Our designers give you customizable options in UI and UX and build the best platform for your enterprise. By treating every client differently, we ensure that the client gets the best possible service. We analyze and monitor user engagement through the UI we have created and make the required changes. Our process puts your needs on top, and your growth becomes our priority.<br/>
        Best Website developers in Mumbai delivering Websites Globally<br/>
        </span>
    </h3>
    <h3>Website Development<br/>
        <span>
        The developers at ShellCode Solutions, the best Website Development Company in Mumbai, are meticulous and work hard to get what you want. Our designers have worked with many clients across different industries. We provide our services on a global scale and give you a website that is worthy of your cause. <br/>
        A Safe And Secure Website is Our Guarantee<br/>
        </span>
    </h3>
    <h3>Website Testing<br/>
        <span>
        A website is not finished until it has gone through all rounds of testing. Even after building the perfect website, the experience can get ruined if you come across bugs. Bugs are something we despise. That is why we conduct multiple rounds of testing to ensure that your website is a safe and secure platform.<br/>
        Launch your dream!<br/></span>
        
    </h3>
    <h3>Website launching<br/>
        <span>
        Who doesn't like a tried and tested product built to amaze the digital world? We at ShellCode Solutions, the best Website Development Company in Mumbai, launch the perfect website after proper CMS integration. We analyze user response to your website and cover a scope for improvement even after launch. In us, you have found a partner in your growth.<br/>

We stay!</span>
    </h3>

    <h3>One year of technical support<br/><span>A website needs maintenance even if it has been built perfectly. We understand that! We provide one year of maintenance and support for your website. We offer a support team that prioritizes your needs and gives you the needed support. Our web development services are not just a product. We value the whole process!</span></h3>
    
    <h3>Get a user-friendly website for your brand!<br/>
    <span>
    Experience and Innovation: We combine both experience and innovation when it comes to website development for any brand and give the best results.<br/>
Tell us what you need: Tell us your expectations from your website and we will build the best website for you.<br/>
Stay updated: Stay in the loop with the development process and enjoy 100% transparency from our team of dedicated developers. <br/>
We only use the best: The best tools and technologies are used to give you the website of your dreams.<br/>
We are your team: We give you a team of highly skilled developers who construct a mobile-responsive and SEO-friendly website for your brand.<br/>
Safe and secure websites: Our priority is delivering a safe and secure website with 0 bugs.<br/>
We cater every Industry</span></h3>
    <h3>Watch us grow<br/>
    <span>
    Watch us grow
Get a glimpse of our success story. Our team of developers is dexterous and provides great attention to detail. We make use of top-notch tools and technologies so that you remain satisfied. Our company stands on the shoulders of our employees who put your needs first.
    </span></h3>
</div>
    </>
)
}

export default Website;
